var orderitems = false;
$( document ).ready(function() {
	orderitems = new cOrderItems();
});

function cOrderItems(){
	var self = this;
	//Only run on /pages/ page.
	if(window.location.href.indexOf("/orderitems") > -1) {
       this.onload();
    }
}

cOrderItems.prototype.onload = function(){
	$('#select-all').click(function() {
	    var checkboxes = $(this).closest('form').find(':checkbox');
	    checkboxes.prop('checked', $(this).is(':checked'));
	});
}
